<template>
    <main>
       <div class="J-content J-image-voucher">
            <!-- <div class="JImg-opciones JImg-opciones--close  J-upload--close"  v-show="upload.status">
                <a href="javascript:void(0)" @click="closeUpload()"><i class="fas fa-times"></i></a>
            </div> -->

           <div class="J-galery-container">
                <div class="J-message-success" v-if="message!=''">
                    {{message}}
                </div>
                <div class="J-galary-icon">
                    <button type="button" data-toggle="tooltip" title="Subir voucher"  v-if="!upload.status" @click="uploadImg()" class="btn J-btn-fixed"><i class="fas fa-camera"></i></button>
                    <button type="button" :disabled="!isSubmit" data-toggle="tooltip" title="Guardar voucher y finalizar" v-if="upload.status" @click="save()" class="btn J-btn-fixed J-btn-fixed-active">
                        <span  v-if="isSubmit" >
                            <i class="fas fa-save"></i>
                        </span>
                         <span v-else class="inactive col-1 icon-container" style="display: block;">
                            <i class="loader"></i>
                        </span>
                    </button>
                </div>
                <div class="J-croppa-image">
                    <croppa v-model="myCroppa" @new-image-drawn="handleNewImage"  @image-remove="closeUpload" prevent-white-space :width="360" :height="500" placeholder=""></croppa>
                </div>
            </div>
           
        </div>
    </main>
</template>
<script>
import { EventBus } from '@/helpers/eventbus/event-bus'

import {mapState,mapMutations} from 'vuex'
import {PaymentService} from '@/services'
import {CompanyStorage,CartStorage,OrderStorage,CouponStorage,UsersStorage} from '@/helpers/storage.js'
const alertify = require('alertifyjs')
export default {
    data(){
        return {
            upload:{
                image:null,
                status:false,
                id_reserva:this.id_reserva
            },
            message:'',
            isSubmit:true,
            myCroppa:{},
            companyStorage:new CompanyStorage(),
            cartStorage:new CartStorage(),
            orderStorage:new OrderStorage(),
            couponStorage:new CouponStorage(),
            usersStorage:new UsersStorage(),
            
        }
    },
    created(){

    },
    props:{
        id_reserva:{type:String,required:false}
    },
    computed:{
        ...mapState(['user','token'])
    },
    methods:{
        closeUpload:function(){
            this.upload.status=false;
            this.$emit('trasactionButton',true)
        },
        uploadImg:async function(){
            this.myCroppa.chooseFile();
            this.upload.status=true;
        },
        
        save:function(){
            var coupon=this.couponStorage.get();
            this.isSubmit=false;
            var data={
                company:this.companyStorage.get(),
                cart:this.cartStorage.get(),
                upload:this.upload,
                coupon:coupon==null?null:coupon._id,
                type_transaction:"transaction_upload",
                order:this.orderStorage.get() 
            }
            PaymentService.createTransaction(data).then(res=>{
                this.sendOrder(res.data.data);
                this.message="Voucher enviado"
                this.couponStorage.remove();
                this.companyStorage.remove();
                this.cartStorage.remove();
                this.orderStorage.remove();
                setTimeout(()=>{
                    EventBus.$emit('showModal')
                    window.location.href="/orders"
                },3000)
                this.isSubmit=true;

            })
            .cath(err=>{
                this.isSubmit=true;

            })
        },
        sendOrder:function(data){
            var users=this.usersStorage.get();
            data.users={
                email:users.email,
                message:`${users.fullname} subio un voucher`,
                fullname:users.fullname,
                photo:[{
                    link:users.photo,
                    name:'',
                }] 
            }
            this.$socket.emit('order',data);
        },
        recuvaUrl(blobUrl){
            var _this=this
            var xhr = new XMLHttpRequest;
            xhr.responseType = 'blob';

            xhr.onload = function() {
            var recoveredBlob = xhr.response;
            
            var reader = new FileReader;
                reader.onload = function() {
                    var blobAsDataUrl = reader.result;
                    URL.revokeObjectURL(blobUrl);
                    _this.upload.status=true               
                    _this.upload.image=blobAsDataUrl               
                };
                reader.readAsDataURL(recoveredBlob);
            };

            xhr.open('GET', blobUrl);
            xhr.send();
        },
        saveImage(type, compressionRate) {
            this.myCroppa.generateBlob((blob) => {
                var url = URL.createObjectURL(blob);
                this.recuvaUrl(url)
                // EventBus.$emit("uploadImage",url)
                // this.$emit('close')
            }, type, compressionRate)

            // var url=this.myCroppa.generateDataUrl();
            // EventBus.$emit("uploadImage",url)
            // this.$emit('close')
        },
        handleNewImage:function(e){
            this.saveImage('image/jpeg')
            
        },
    }
}
    if(!alertify.myAlert){
  //define a new dialog
    alertify.dialog('myAlert',function factory(){
        return{
        build:function(){
            var header=`Servicio solicitado`
            this.setHeader(header)
        },
        main:function(message){
            this.message = message;
        },
        setup:function(){
            return { 
                buttons:[{text: "Ok", key:27/*Esc*/}],
                focus: { element:0 }
            };
        },
        prepare:function(){
            this.setContent(this.message);
        },
        callback:function(closeEvent){
        },
        hooks:{
            onclose: function(){
                const companyStorage=new CompanyStorage();
                const cartStorage=new CartStorage();
                const orderStorage=new OrderStorage();
                const couponStorage=new CouponStorage();
                couponStorage.remove();
                companyStorage.remove();
                cartStorage.remove();
                orderStorage.remove();
                window.location.href="/orders"
            },
        }
    }});
    }
</script>